import { SearchableSelect } from '../../../../molecules/inputs/SearchableInputs/SearchableSelect';
import { SearchableSelectWithOptionData } from '../../../../molecules/inputs/SearchableInputs/types';
import { useSearchAccountCodesFun } from './hooks';

export interface SearchAccountCodesInputProps
  extends Pick<
    SearchableSelectWithOptionData,
    | 'onChange'
    | 'value'
    | 'placeholder'
    | 'label'
    | 'comboboxProps'
    | 'disabled'
    | 'renderOption'
    | 'filter'
    | 'dataRef'
  > {
  causeId: string;
}

const SearchAccountCodesInput = ({ causeId, ...props }: SearchAccountCodesInputProps) => {
  const useSearchFn = useSearchAccountCodesFun(causeId);
  return <SearchableSelect useFetchSource={useSearchFn} {...props} />;
};
export { SearchAccountCodesInput };
